import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import template from './../../../templates/PageLayout/Popups/Modal.rt';

const mapStateToProps = (state) => {
  const {modal} = state.popups;
  return {
    ...modal
  }
};

class Modal extends PureComponent {
  static propTypes = {
    visible: PropTypes.bool.isRequired,
    message: PropTypes.string.isRequired,
    buttons: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      color: PropTypes.string
    }))
  };
  render = template;
}

export default connect(mapStateToProps)(Modal);

